import env from './env';

export default {
  dsn: env('SENTRY_DSN'),
  // Do not add private variables here, as they will be included in the bundle.
};
